import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { LatestArticles } from "./LatestArticles";
import { TagsListControl } from "./controls/TagsListControl";
import { SettingsContext } from "../../../infrastructure/SettingsContext";
import { ApiDataAccess } from "../../common/ApiDataAccess";
import { Logger } from "../../../infrastructure/Logger";
import { Cache } from "../../common/Cache";
import { Search } from "react-feather";
import "./HomeView.css";

export const HomeView = (props) => {
    const { settings } = useContext(SettingsContext);
    const [allTags, setAllTags] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const dataAccess = new ApiDataAccess("/api/Tags");
    const cache = new Cache("tag-list", 30);
    const navigate = useNavigate();
    const searchRef = useRef(null);

    //const driveSearchModal = useModal(DriveSearchViewModal);
    useEffect(() => {
        console.log("!!load!", settings);
        cache
            .getOrAdd("all" + Math.random(), function (key) {
                return new Promise(function (resolve, reject) {
                    console.log("debug: fetch all tags");
                    dataAccess.get(
                        "/",
                        (data) => {
                            resolve(data);
                        },
                        (err) => {
                            Logger.writeError(err);
                            reject(err);
                        }
                    );
                });
            })
            .then((data) => {
                setAllTags(data);
            });
    }, []);
    // constructor(props) {
    //     super(props);

    //     this.state = {
    //         value: null,
    //     };

    //     this.onKeyPress = this.onKeyPress.bind(this);
    //     this.onChange = this.onChange.bind(this);
    //     this.onSearchClick = this.onSearchClick.bind(this);
    //     this.onAssistantClick = this.onAssistantClick.bind(this);
    // }

    const [value, setValue] = useState({
        value: "",
    });

    const onChange = (event) => {
        var value = event.target.value;
        var valueToUpdate = value && value.length > 0 ? value : null;
        setSearchTerm(valueToUpdate);
    };

    const onKeyPress = (event) => {
        if (event.key === "Enter") {
            search(value);
        }
    };

    const onSearchClick = () => {
        search(searchTerm);
    };

    const onAssistantClick = () => {
        //askAssistant(value);

        //driveSearchModal.show();
        console.log("??");
    };

    const search = (term) => {
        //Router.setRoute("/search?term=" + encodeURIComponent(term));
        console.log("search", term);
        if (term && term.trim() !== "") {
            navigate("/search?term=" + encodeURIComponent(term));
        }
        else {
            searchRef.current.focus();
        }
    };

    const askAssistant = (term) => {
        //Router.setRoute("/ask?term=" + encodeURIComponent(term));
    };

    const onStartImport = (modal) => {
        modal.close();
    };

    const onImportClick = () => {
        //NiceModal.show(<DriveSearchViewModal />, {});
        // NiceModal.show('my-modal', {
        //     someProp: 'hello'
        // },
        // (modal) => {
        //     return (
        //         <DriveSearchView
        //             modal={modal}
        //             onImported={(id) => {
        //                 //Router.setRoute("/articles/" + id);
        //                 <Navigate to={`/articles/${id}`} />;
        //             }}
        //             onError={() => {
        //                 //Alerts.showError("The Document was not imported. Probably this article exists already");
        //             }}
        //         />
        //     );
        // }, <span>Import Google Doc</span>);
    };

    const onTagClick = (tag) => {
        //Router.setRoute('/tags/' + tag.id + '/articles');
        console.log("navigate to tag", tag);
        navigate(`/tags/${tag.id}/articles`);
    };

    return (
        <div className="view home-view">
            <div
                className="btn-round fixed-right background-green"
                onClick={() => {
                    //Router.setRoute("/articles/new");
                    <Navigate to="/articles/new" />;
                }}
            >
                <span className="glyphicon glyphicon-plus"></span>
            </div>

            {/* {settings.GOOGLE_IMPORT_ENABLED && (
                <div
                    className="btn-round fixed-left background-blue"
                    onClick={() => {
                        onImportClick();
                    }}
                >
                    <span className="glyphicon glyphicon-book"></span>
                </div>
            )} */}

            <h2>Search Articles</h2>
            <div className="search-container">
                <input ref={searchRef} className="control" onChange={onChange} onKeyDown={e => {
                    if (e.key === "Enter") {
                        search(searchTerm);
                    }
                }}></input>
                {/* {settings.GOOGLE_IMPORT_ENABLED && (
                            <button className="btn btn-success" type="button" onClick={onAssistantClick}>
                                <span className="glyphicon glyphicon-user"></span>
                            </button>
                        )} */}

                <button className="btn btn-primary" type="button" onClick={onSearchClick}>
                    <span className="glyphicon glyphicon-search">
                        <Search />
                    </span>
                </button>
            </div>
            <div>
            <button
                    className="btn btn-primary"
                    type="button"
                    onClick={(e) => {
                        navigate("/articles/new");
                    }}
                >
                    <span className="glyphicon glyphicon-search">New Article</span>
                </button>
            </div>
            <h3>Latest Articles</h3>
            <LatestArticles />

            <h4>Popular Categories</h4>
            <TagsListControl tags={allTags} onTagClick={onTagClick} />
        </div>
    );
};
